import { render, staticRenderFns } from "./gun-detail.vue?vue&type=template&id=e7cdb37a&"
import script from "./gun-detail.vue?vue&type=script&lang=ts&"
export * from "./gun-detail.vue?vue&type=script&lang=ts&"
import style0 from "./gun-detail.vue?vue&type=style&index=0&id=e7cdb37a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports